<template>
  <div
    class="fullWdth header"
    :style="noticeshow ? 'height:89px' : 'height:38px'"
  >
    <div class="notice" v-if="noticeshow" @click="showtips = true">
      <span>{{ data[0].title }}</span>
      <i class="el-icon-close" @click="noticeshow = false" @click.stop></i>
    </div>
    <div class="controlWdth bg-f2">
      <div
        class="float-left"
        v-if="
          this.$store.state.webInfo.base_conf.is_user_name == 1 ||
            this.$store.state.webInfo.base_conf.is_fudou == 1
        "
      >
        <!-- <div class="site">
          <i class="el-icon-location"></i>
          <span>{{popAddress.xq}}</span>
          <i class="el-icon-arrow-down"></i>
          <div class="sitelist noselect">
            <div class="sitenav">
              <span
                v-for="(item,index) in popAddress.area"
                :key="index"
                @click="choseaddress(index)"
              >{{item}}</span>
            </div>
            <ul>
              <li
                v-for="(item,index) in sitelist"
                :key="index"
                @click="seletesite(item.id,item.name)"
              >{{item.name}}</li>
            </ul>
          </div>
        </div> -->

        <span
          v-if="$store.state.user_id != 'null' && $store.state.user_id != ''"
          class="head-tit"
        >
          <span v-if="$store.state.webInfo.base_conf.is_user_name == 1">
            <img
              :src="$store.state.userinfo.image"
              onerror="src='/static/img/default.png'"
              v-if="$store.state.userinfo.image != null"
              alt
            />
            <img v-else src="/static/img/default.png" />
            用户<router-link :to="{ name: 'Personal' }">{{
              $store.state.userinfo.user_name == ""
                ? tels($store.state.userinfo.account)
                : $store.state.userinfo.user_name
            }}</router-link>
          </span>
          &nbsp;&nbsp;&nbsp;<span
            v-if="$store.state.webInfo.base_conf.is_fudou == 1"
          >
            {{ $store.state.name }}:{{ $store.state.userinfo.point }}
          </span>
        </span>
        <span class="hy" v-else
          >你好，欢迎来到{{ $store.state.webInfo.name }}!</span
        >

        <!-- {{ $store.state }} -->
      </div>
      <ul class="float-right">
        <!-- <li>
          <router-link
            :to="{name:'Login',params: {type: 0}}"
            v-if="$store.state.user_id=='null'&&$store.state.webInfo.register_status==1||$store.state.user_id==''&&$store.state.webInfo.register_status==1"
          >注册</router-link>
        </li> -->
        <li>
          <router-link
            :to="{ name: 'Login', params: { type: 1 } }"
            v-if="$store.state.user_id == 'null' || $store.state.user_id == ''"
            >请登录</router-link
          >
        </li>
        <!-- <li v-if="$store.state.user_id != 'null' && $store.state.user_id != ''">
          <router-link :to="{ name: 'Personal' }">{{
            $store.state.userinfo.user_name == ""
              ? tels($store.state.userinfo.account)
              : $store.state.userinfo.user_name
          }}</router-link>
        </li> -->
        <li
          v-if="$store.state.user_id != '' && $store.state.user_id != 'null'"
          @click="out()"
        >
          <router-link to>退出登录</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Mypoints' }"
            >我的{{
              $common.cardName().type ? "余额" : $store.state.name
            }}</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'Myorder' }">我的订单</router-link>
        </li>
        <li>
          <router-link to="/user">个人中心</router-link>
        </li>
        <li style="padding-left:20px;">
          <div
            style="background: #E23130;
    padding: 0px 9px 0px 8px;"
            :style="[
              {
                background:
                  $store.state.user_id == 'null' || $store.state.user_id == ''
                    ? 'rgba(255, 255, 255, 0.3)'
                    : ' #E23130'
              }
            ]"
            @click="cart()"
          >
            <img src="/static/img/cart-icon.svg" style="width:24px;" />
            <span
              >{{ $common.cardName().name }}({{ $store.state.cartnum }})</span
            >
          </div>
        </li>
      </ul>
    </div>
    <el-dialog :visible.sync="showtips" width="920px" center>
      <div slot="title" class="tips-header">
        <div class="rect theme-bg"></div>
        <div class="dialog-title f-b" v-if="noticeshow">
          {{ data[0].title }}
        </div>
      </div>
      <div>
        <p style="font-size: 16px;">尊敬的客户：</p>
        <p
          style="line-height: 24px;text-indent: 2em;font-size: 16px;"
          v-if="noticeshow"
        >
          你好！{{ data[0].message }}
        </p>
        <p
          style="text-align: right;line-height: 20px;font-size: 16px;margin-right: 30px;"
          v-if="noticeshow"
        >
          运营中心
          <br />
          {{ times(data[0].add_time) }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from "../vuex/store";
import Jsonp from "jsonp";
export default {
  name: "",
  data() {
    return {
      list: "",
      noticeshow: false,
      showtips: false,
      data: [{ title: "44" }],
      popAddress: this.$store.state.address,
      sitelist: [],
      index: 0
    };
  },
  store,
  methods: {
    cart() {
      this.$router.push({ name: "Cart" });
    },
    out: function() {
      this.$confirm("请确认是否退出", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.get(
            "user/logout",
            {
              id_example: this.$store.state.id_example,
              token_user: this.$store.state.user_id
            },
            res => {
              if (res.data.code == 100) {
                this.$store.state.cartnum = "0";
                this.$store.state.user_id = "null";
                this.$store.state.userinfo = "";
                window.localStorage.clear();
                localStorage.setItem(
                  "messageStore1",
                  JSON.stringify(this.$store.state)
                );
                this.$router.push({ name: "Login", params: { type: 1 } });
                window.history.go(0);
              } else if (res.data.code == -101) {
                this.$store.state.cartnum = "0";
                this.$store.state.user_id = "null";
                this.$store.state.userinfo = "";
                window.localStorage.clear();
                localStorage.setItem(
                  "messageStore1",
                  JSON.stringify(this.$store.state)
                );
                this.$router.push({ name: "Login", params: { type: 1 } });
                window.history.go(0);
              }
            }
          );
        })
        .catch(() => {});
    },
    tels(tel) {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      if (tel != null) {
        tel = tel.replace(reg, "$1****$2");
      }
      return tel;
    },
    announcement() {
      this.$api.get(
        "sys/notice",
        {
          id_example: this.$store.state.id_example
        },
        res => {
          if (res.data.data.length != 0) {
            this.noticeshow = true;
            this.data = res.data.data;
          }
        }
      );
    },
    times: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m;
      if (date.getMinutes() < 10) {
        m = "0" + date.getMinutes() + ":";
      } else {
        m = date.getMinutes() + ":";
      }
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    // 选择地址
    choseaddress: function(index) {
      this.index = index;
      var id = 0;
      switch (this.index) {
        case 0:
          id = 4744;
          break;
        case 1:
          id = this.popAddress.id[0];
          break;
        case 2:
          id = this.popAddress.id[1];
          break;
        case 3:
          id = this.popAddress.id[2];
          break;
      }
      var _this = this;
      // Jsonp('https://fts.jd.com/area/get?fid=' + id, null, (err, data) => {
      //      if (err) {
      //        return this.$toast('获取地址失败');
      //      }
      //       _this.sitelist=data;
      //    });
      if (this.index == 0) {
        this.$api.post(
          "address/address/getProvince",
          { id_example: this.$store.state.id_example, parent_id: 0 },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 1) {
        this.$api.post(
          "address/address/getCity",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 2) {
        this.$api.post(
          "address/address/getCounty",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 3) {
        this.$api.post(
          "address/address/getTown",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      // this.$api.get(
      //   "sys/address",
      //   {
      //     id_example: this.$store.state.id_example,
      //     parent_id: id
      //   },
      //   res => {
      //     if (res.data.code == 100) {
      //       this.sitelist = [];
      //       var _this = this;
      //       $.each(res.data.data, function(index, item) {
      //         var arr = { id: index, name: item };
      //         _this.sitelist.push(arr);
      //       });
      //     }
      //   }
      // );
    },
    seletesite: function(id, name) {
      switch (this.index) {
        case 0:
          this.popAddress.id = [id, 0, 0, 0];
          this.popAddress.area = [name, "", "", ""];
          this.index++;
          break;
        case 1:
          if (this.popAddress.id[0] == id) {
            return false;
          }
          this.popAddress.id[1] = id;
          this.popAddress.area[1] = name;
          this.popAddress.id[2] = "";
          this.popAddress.area[2] = "";
          this.popAddress.id[3] = "";
          this.popAddress.area[3] = "";
          this.index++;
          break;
        case 2:
          if (this.popAddress.id[1] == id) {
            return false;
          }
          this.popAddress.id[2] = id;
          this.popAddress.ti++;
          this.popAddress.area[2] = name;
          this.popAddress.id[3] = "";
          this.popAddress.area[3] = "";
          this.index++;
          break;
        case 3:
          if (this.popAddress.id[2] == id) {
            return false;
          }
          if (name == this.popAddress.area[2]) {
            break;
          }
          this.popAddress.id[3] = id;
          this.popAddress.ti++;
          this.popAddress.area[3] = name;
          this.index++;
          break;
      }
      var _this = this;
      if (this.index == 1) {
        this.$api.post(
          "address/address/getCity",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 2) {
        this.$api.post(
          "address/address/getCounty",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 3) {
        this.$api.post(
          "address/address/getTown",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      // this.$api.get(
      //   "sys/address",
      //   {
      //     id_example: this.$store.state.id_example,
      //     parent_id: id
      //   },
      //   res => {
      //     if (res.data.code == 100) {
      //       if ((res.data.data == false)) {
      //         if(this.index!=4){
      //           this.index=2
      //         }else{
      //           this.index=3
      //         }
      //         return false;
      //       }
      //       this.sitelist = [];
      //       var _this = this;
      //       $.each(res.data.data, function(index, item) {
      //         var arr = { id: index, name: item };
      //         _this.sitelist.push(arr);
      //       });
      //     }
      //   }
      // );
      this.$store.commit("setAddress", this.popAddress);
    },

    fistes: function(id) {
      // Jsonp('https://fts.jd.com/area/get?fid=4744', null, (err, data) => {
      //   if (err) {
      //        return this.$toast('获取地址失败');
      //      }
      //      let siteData=[]
      //      for (let key in data){
      //   if (key === '52993' || data[key].name === '港澳') {
      //     continue;
      //   }
      //   if (key === '32' || data[key].name === '台湾') {
      //     continue;
      //   }
      //   if (key === '84' || data[key].name === '钓鱼岛') {
      //     continue;
      //   }
      //         if (key === '53283' || data[key].name === '海外') {
      //             break;
      //         }else{
      //           siteData.push(data[key]);
      //         }
      //     }
      //   this.sitelist=siteData;
      // })
      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            this.sitelist = res.data.data;
          }
        }
      );
      // this.$api.get(
      //   "sys/address",
      //   {
      //     id_example: this.$store.state.id_example,
      //     parent_id: id
      //   },
      //   res => {
      //     if (res.data.code == 100) {
      //       if ((res.data.data == false)) {
      //         return false;
      //       }
      //       this.sitelist = [];
      //       var _this = this;
      //       $.each(res.data.data, function(index, item) {
      //         var arr = { id: index, name: item };
      //         _this.sitelist.push(arr);
      //       });
      //     }
      //   }
      // );
    }
  },
  mounted() {
    this.announcement();
    this.fistes(0);
    console.log(this.popAddress);
  }
};
</script>

<style lang="less">
.header {
  // position: fixed;
  // top: 0;
  height: 38px;
  z-index: 1000;
  background: #333 !important;
  // box-shadow: 0px 2px 5px #e0dede;
  line-height: 38px;
  width: 100%;
  display: block;
  p {
    color: #8b8b8b;
    font-size: 13px;
  }
  .bg-f2 {
    background: #f3f3f3 !important;
    span {
      color: rgba(255, 255, 255, 0.8);
      cursor: default;
      &:hover {
        color: rgba(255, 255, 255, 1);
      }
      &.hy:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .head-tit {
      img {
        width: 24px;
        height: 24px;
      }
      a {
        color: rgba(255, 210, 147, 0.8);
      }
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 210, 147, 0.8);
      a:hover {
        color: rgba(255, 210, 147, 0.8);
      }
      &:hover {
        color: rgba(255, 210, 147, 0.8);
      }
    }
    // &:hover{
    //   span{
    //      color:rgba(255,255,255,1);
    //   }
    // }
  }
  .bg-f2 a {
    color: rgba(255, 255, 255, 0.8);
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
  ul {
    padding-left: 0;
  }
  span {
    cursor: pointer;
    color: #fff;
    font-size: 13px;
  }
  li {
    display: inline-block;
    padding-left: 25px;
    height: 100%;
    font-size: 13px;
    // font: 12px/1.5 Microsoft YaHei, tahoma, arial, Hiragino Sans GB, \\5b8b\4f53,
    //   sans-serif;
    a {
      font-size: 13px;
      line-height: 33px;
      color: #fff;
    }
  }
  .notice {
    line-height: 56px;
    height: 56px;
    background: #fce300;
    font-size: 20px;
    font-weight: 500;
    span {
      width: 1000px;
      display: inline-block;
    }
    i {
      cursor: pointer;
      font-weight: 600;
      color: white;
    }
    .el-icon-close:before {
      border: 2px solid white;
      border-radius: 50%;
    }
  }
  .rect {
    width: 25px;
    height: 6px;
    border-radius: 3px;
    margin: 0px auto 0px auto;
  }
  .site {
    display: inline-block;
    margin-right: 20px;
    box-sizing: border-box;
    padding: 0 5px;
    color: #fff;
    position: relative;
    &:hover {
      // background: white;
    }
    &:hover > .sitelist {
      display: block;
    }
  }
  .sitelist {
    position: absolute;
    top: 38px;
    left: 0;
    display: none;
    width: 440px;
    min-height: 240px;
    background: white;
    border: 1px solid #e7e7e7;
    z-index: 99;
    text-align: left;
    .sitenav {
      border-bottom: 1px solid #f3f3f3;
    }
    ul {
      li {
        color: #939393;
        min-width: 50px;
        border: none;
        text-align: center;
      }
    }
    span {
      color: #939393;
      display: inline-block;
      padding: 0 15px;
      min-width: 50px;
    }
    .active {
      color: #000;
    }
  }
  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */

    -webkit-user-select: none; /* Chrome/Safari/Opera */

    -khtml-user-select: none; /* Konqueror */

    -moz-user-select: none; /* Firefox */

    -ms-user-select: none; /* Internet Explorer/Edge */

    user-select: none; /* Non-prefixed version, currently

  not supported by any browser */
  }
}
</style>



// WEBPACK FOOTER //
// src/common/header.vue